<template>
  <div :id="id">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'CustomCollapse',
  meta: {
    description: 'Componente padre del CustomCollapseItem',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    id: {
      type: String,
      required: true,
      default: 'idCustomCollapse',
      meta: {
        description: 'Id contenedor para los CustomCollapse',
        example: 'idCustomCollapse',
      },
    },
  },
};
</script>
